import { render, staticRenderFns } from "./modelCommand.vue?vue&type=template&id=c8f2a172&scoped=true&"
import script from "./modelCommand.vue?vue&type=script&lang=js&"
export * from "./modelCommand.vue?vue&type=script&lang=js&"
import style0 from "./modelCommand.vue?vue&type=style&index=0&id=c8f2a172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f2a172",
  null
  
)

export default component.exports